import React from 'react'
import DataLoader from '../data/DataLoader'
import VimeoPlayer from '../misc/VimeoPlayer'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import MetaTags from 'react-meta-tags'

class LandingPage extends React.Component {

  constructor(){
    super();
    this.setVideoSize = this.setVideoSize.bind(this);
    this.lookForVideo = this.lookForVideo.bind(this);

    this.state = {
        videoStyle: {},
        videoFound: false
    }
  }


  componentDidMount(){
    this.lookForVideo();
    window.addEventListener('resize',this.setVideoSize);

  }
  componentWillUnmount(){
    window.removeEventListener('resize',this.setVideoSize);
  }

  componentDidUpdate(){
    //  console.log("Video Updated Load",this.refs);

  }

  setVideoSize(e){
    console.log("setVideoSize");

    let video = document.querySelector('#videoloop')

    let w = video.getAttribute('original-width')//this.refs.introloop.videoWidth
    let h = video.getAttribute('original-height')//this.refs.introloop.videoHeight

    ///console.log(w,h);


    let ww = window.innerWidth
    let wh = window.innerHeight



    let videoStyle

    let hScale = ww/w
    let vScale = wh/h


    if(h*hScale < wh){
      //console.log('go with height');
      videoStyle = {
          minHeight:(h*vScale)+'px',
          minWidth:(w*vScale)+'px'
      }

    }else{
      //console.log('go with width');
      videoStyle = {
          minHeight:(h*hScale)+'px',
          minWidth:(w*hScale)+'px'
      }
    }

    this.setState({videoStyle});


  }

  lookForVideo(){

    //console.log('Look for video');
    let video = document.querySelector('#videoloop')
    if(video){
      console.log('Found video', video);
      //video.addEventListener('play',this.setVideoSize)
      //video.addEventListener('load',this.setVideoSize)
      //video.addEventListener('timeupdate',this.setVideoSize)
      //video.addEventListener('timeupdate',this.setVideoSize)
      this.setVideoSize();
      this.setState({videoFound:true})
    }else{
      setTimeout(this.lookForVideo,10)
    }
  }


  render () {


        //console.log("Landing Page",this.props);


        let content

        (this.props.pagesData)?

          content = this.props.pagesData.data.filter((item,index) => {

                return (item.slug==='home');

          })[0]

        : null ;

      //console.log('Home',content);
      /*
      (content)?
        (content.acf.background_video && !this.state.videoFound)?
          //this.lookForVideo()
        : null
      : null */

        return(
          <DataLoader load="pages">
          {(content)?
            <div className="landing-page">

              <MetaTags>
                <meta id="meta-description" name="description" content={content.acf.meta_description} />
                <title>{'The Fyzz'}</title>
                <meta id="og-title" property="og:title" content={'The Fyzz - Facility | '+content.title.rendered} />
              </MetaTags>

                <div className="background" style={{backgroundImage:'url('+content.acf.background_image.url+')'}}>
                  <div className="intro-logo"></div>
                  <div className="intro-video">
                      <div className="inner-video" style={this.state.videoStyle}>
                        {
                          (content.acf.background_video)?
                          (
                            <div dangerouslySetInnerHTML={{ __html: `
                              <video
                                muted
                                autoplay
                                playsinline
                                id="videoloop"
                                loop
                                original-width=${content.acf.background_video.width}
                                original-height=${content.acf.background_video.height}
                                src="${content.acf.background_video.url}"
                              />
                            ` }}></div>
                          )
                          : null
                        }



                      </div>

                  </div>



                  <VimeoPlayer video={content.acf.show_reel} />
                  </div>

                  <div className="bottom-coloumns">
                    {
                      content.acf.columns.map((item,index) => {
                          return <div key={'c'+index} className="col" dangerouslySetInnerHTML={{__html:item.column}}></div>
                      })
                    }
                  </div>



            </div>
           : null }
          </DataLoader>
        )
  }
}

const mapStateToProps = (state) => {
  const pagesData = state.pagesData
    return{
      pagesData
    }
}

const VideoWorkaround = ({ src }) => (
  <div dangerouslySetInnerHTML={{ __html: `
    <video
      muted
      autoplay
      playsinline
      src="${src}"
    />
  ` }}
  />
);

export default connect(mapStateToProps)(LandingPage);



// WEBPACK FOOTER //
// ./src/modules/pages/LandingPage.js